import moment from "moment"

import getters from '@/store/general/getters'
import state from '@/store/general/state'

export const capitalizeText = text => {
  if (typeof text !== 'string') return text
  text = text.toLowerCase()
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export const sanitizeAmount = (amount) => {
  const currencySuffix = getters.currencySuffix(state);
  let localeAmount = '0.00';

  if (amount) {
    localeAmount = amount.toLocaleString(undefined, {
      minimumFractionDigits: 2
    });
  }
  return `${currencySuffix} ${localeAmount}`;
}

export const formatAmount = amount => {
  if (amount) {
    if(typeof amount === 'string') {
      amount = amount.replace(/,/g, '')
      amount = parseFloat(amount)
    }

    return amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
  return 0.00
}

export const getCategorizedComments = (comments, viewRequestedComment) => {
  let categorizedPreAuditComments = {}
  let categorizedConcurrentComments = {}
  let commentsByView = {}

  switch (viewRequestedComment) {
    case 'ACCOUNT_VIEW':
      if (Object.keys(comments).length > 0) {
        commentsByView = comments.filter(item => item.chargeId === null)
      }
      break
    case 'CHARGE_VIEW':
      commentsByView = comments
      break
  }

  if (Object.keys(commentsByView).length > 0) {
    const preAuditType = commentsByView.filter(type => type.auditType === 'PRE_AUDIT')
    const concurrentType = commentsByView.filter(type => type.auditType === 'CONCURRENT')

    const addCommentCategory = commentType => {
      return commentType.map(comment => {
        if (comment.chargeId === null && comment.chargeCode === null) {
          comment.commentCategory = 'GENERAL'
        } else {
          comment.commentCategory = 'CHARGE'
        }
        return comment
      })
    }
    if (preAuditType) {
      categorizedPreAuditComments = addCommentCategory(preAuditType)
    }

    if (concurrentType) {
      categorizedConcurrentComments = addCommentCategory(concurrentType)
    }
  }

  const orderComments = commentsByView => {
    if (Object.keys(commentsByView).length > 0) {
      return commentsByView.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt)
      })
    } else {
      return commentsByView
    }
  }

  const categorizedComments = {
    preAuditComments: orderComments(categorizedPreAuditComments),
    concurrentComments: orderComments(categorizedConcurrentComments)
  }

  return categorizedComments
}

export const generateCommentPayload = (action, targetComment, commentsList, newComment) => {
  let selectedComment

  if (action) {
    switch (action) {
      case 'resolved-comment':
        selectedComment = commentsList.filter(
          comment => comment.commentId === targetComment.commentId
        )

        if (Object.keys(selectedComment).length > 0) {
          const accountId = selectedComment[0].accountId
          const chargeId = selectedComment[0].chargeId
          const payload = {
            replace: {
              comments: [
                {
                  comment_id: selectedComment[0].commentId,
                  charge_id: null,
                  comment: selectedComment[0].comment,
                  audit_type: selectedComment[0].auditType,
                  resolved: !selectedComment[0].resolved
                }
              ]
            }
          }
          return { accountId, chargeId, payload }
        }
        break

      case 'add-comment': {
        if (targetComment) {
          const payload = {
            add: {
              comments: [
                {
                  comment_id: null,
                  charge_id: targetComment.chargeId,
                  comment: targetComment.comment,
                  audit_type: targetComment.auditType,
                  resolved: null
                }
              ]
            }
          }
          return payload
        }
        break
      }

      case 'edit-comment': {
        if (targetComment) {
          const payload = {
            replace: {
              comments: [
                {
                  comment_id: targetComment.commentId,
                  charge_id: targetComment.chargeId,
                  comment: newComment,
                  audit_type: targetComment.auditType,
                  resolved: targetComment.resolved
                }
              ]
            }
          }
          return payload
        }
        break
      }

      case 'delete-comment': {
        if (targetComment) {
          const { commentId } = targetComment
          const payload = {
            remove: {
              commentIds: [commentId]
            }
          }
          return payload
        }
      }
    }
  }
}

export const getNow = (format = "DD/MM/YYYY HH:mm:ss") => {
  return moment().format(format)
}

export const updateFilter = (filters, payload) => {
  const index = filters.findIndex(filter => filter.slug === payload.slug)

  if (index >= 0) {
    if(!payload.value){
      filters.splice(index, 1)
      return filters
    }

    filters[index].value = payload.value

  } else {
    if(!payload.value) return filters
    filters.push({ slug: payload.slug, value: payload.value })
  }

  return filters
}

export const convertFiltersToObject = filters => {
  const filtersObject = {}

  filters.forEach(filter => {
    filtersObject[filter.slug] = filter.value
  })

  return filtersObject || {}
}

export const getFilterValue = (slug, filters) => {
  const filter = filters.find(filter => filter.slug === slug)
  return filter ? filter.value : null
}

export const camelToSnake = text => {
  return text.replace(/[A-Z]/g, match => '_' + match.toLowerCase());
}

export const textToSnake = text => {
  text = text.toLowerCase();
  
  return text.replace(/\W+/g, " ")
    .split(/ |\B(?=[A-Z])/)
    .join('_');
};

export const camelize = text => {
  return text.replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return index === 0 ? word.toLowerCase() : word.toUpperCase();
  }).replace(/\s+/g, '');
}

export const sortArray = (array, key, order = 'asc') => {
  return array.sort((a, b) => {
    if (order === 'asc') {
      return a[key] > b[key] ? 1 : -1
    } else {
      return a[key] < b[key] ? 1 : -1
    }
  })
}

export const formatStringToValidPath = (str, mode) => {
  if (!str) return ''

  str = str.replace(/\/{2,}/g, "/");
  str = str.replace(/\/[^a-zA-Z0-9]+\/+/g, "/");

  switch (mode) {
    case 'start': 
      str = str.replace(/\/+$/, "");
      return str.startsWith('/') ? str : "/" + str;
    case 'final': 
      str = str.replace(/^\/+/, "");
      return str.endsWith('/') ? str : str + "/";
    default: 
      return str
  }
}

export const sanitizeAndNormalizeText = (text) => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[`´‘’‚‛‹›'’]/g, "'")
    .trim();
}

export const sanitizeAndCapitalizeFieldValue = (field) => {
  if (!field) return '';
  return field
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/(^\w|\s\w)/g, (match) => match.toUpperCase());
}
